<template>
<div class="slide slide01">
	<h3 class="title">GnM performance만의 <br class="mo">차별화 서비스를 제공합니다</h3>
	<div class="text">
		기존의 퍼포먼스 광고 대행사가 검색광고, <br class="mo">퍼포먼스광고 운영과 AD-Tech 중심인 반면에 <br> GnM performance는 운영과 AD-tech 역량에 <br>그랑몬스터와 메큐라이크의 전략 기획과 크리에이티브 역량을 이식하였습니다.
	</div>

	<div class="featureList">
		<img src="@/assets/images/featureSlide01Img.png" alt="" v-if="$device.windows">
		<div class="serviceImg" v-else>
			<img src="@/assets/images/featureSlide01ImgMo.png" alt="">
		</div>
		<ul class="list">
			<li class="no1">퍼포먼스 기획 역량</li>
			<li class="no2">퍼포먼스 운영</li>
			<li class="no3">AD-Tech</li>
			<li class="no4">크리에이티브 역량</li>
		</ul>
	</div>
	<div class="btnsWrap">
		<a herf="javascript:;" @click="fnSlickNext" class="slideNextBtn" v-if="!$device.windows">다음 페이지</a>
	</div>
</div>
</template>
<script>
export default {
	methods:{
		fnPopClose(){
			this.$emit('popClose' , event)
		},
		fnSlickNext(){
			this.$emit('slick_next' , event)
		}
	}
}
</script>